import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import Select from 'react-select';

import SmsAPI from '../../api/SmsAPI';
import Const from '../../util/Constants';
import Util from '../../util/Util';
import ApiUiController from '../../controller/ApiUiController';

import './SmsPopup.css';

class SmsPopup extends React.Component {

  constructor(props) {
    super(props);
    this.options = reactLocalStorage.getObject(Const.Model).sms_temp.options;
    
    this.phones = [];
    if(props.data.phone && props.data.phone !== '' && props.data.phone !== '~~') {
      this.phones = props.data.phone.substring(1, props.data.phone.length - 1).split(Const.Opt)
        .map( value => { return { label: value }});
    }
    
    this.sms = { id: 0, type: 1, model_no: props.model_no, model_id: props.model_id };
    this.state = { inApiCall: false, changed: false, temp: null, phone: this.phones.length > 0 ? this.phones[0] : null, text: '' };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.data && props.data.id !== this.props.data.id) {
      this.phones = [];
      if(props.data.phone && props.data.phone !== '' && props.data.phone !== '~~') {
        this.phones = props.data.phone.substring(1, props.data.phone.length - 1).split(Const.Opt)
          .map( value => { return { label: value }});
      }
    
      this.sms = { id: 0, type: 1, model_no: props.model_no, model_id: props.model_id };
      this.setState({ ...this.state, phone: this.phones.length > 0 ? this.phones[0] : null });
    }
  }

  onChange = temp => {
    const text = temp ? Util.templateToData(temp.text, this.props.data, this.props.model.fields).template : '';
    this.setState({ ...this.state, temp, text });
  }
  onValueChange = evt => this.setState({ ...this.state, text: evt.target.value });
  onPhone = phone => this.setState({ ...this.state, phone });

  onSave = () => {
    if(this.state.text === '') { Util.showNotification('Error', 'Sms is empty', 'danger'); return; }
    if(!this.state.phone) {
      Util.showNotification('Error', 'Phone are empty', 'danger'); 
      return;
    }
    this.setState({ ...this.state, inApiCall: true });
    SmsAPI.send(0, this.props.model_no, this.props.model_id, this.state, this.onSaved, this.failure);
  }
  onSaved = () => {
    Util.showNotification('Successful', 'Sms sent successfully', 'success');
    this.setState({ ...this.state, inApiCall: false });
    this.props.onHide();
    if(this.props.reload) {
      this.props.reload();
    }
  }

  failure = res => {
    Util.showNotification('Failed', res.message, 'danger');
    this.setState({ ...this.state, inApiCall: false });
  }

  render() {
    return (
      <Modal {...this.props} size="md" aria-labelledby="contained-modal-title-vcenter" centered >
        
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">SMS</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <ApiUiController inApiCall={this.state.inApiCall}>
              <div className="col">
                <div className="form-group">
                  <label>Select Template</label>
                  <Select value={this.state.temp} onChange={this.onChange}
                    options={this.options} isSearchable={true} isClearable={true} />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label>Select Phone</label>
                  <Select value={this.state.phone} onChange={this.onPhone}
                    options={this.phones} isSearchable={true} isClearable={true} isMulti={false} />
                </div>
              </div>
              
              <div className="col">
                <div className="form-group">
                  <label>SMS Text</label>
                  <FormControl as="textarea" placeholder="Text" className="mr-sm-2"
                    value={this.state.text} onChange={this.onValueChange} rows={3} />
                </div>
              </div>
            </ApiUiController>
          </Form>
        </Modal.Body>
        <Modal.Footer><Button onClick={this.onSave}>Submit</Button></Modal.Footer>
      </Modal>
    );
  }
}
export default SmsPopup;